const capVerifierActions = {


   CREATE_CAP_VERIFIER : "CREATE_CAP_VERIFIER",
   UPDATE_CAP_VERIFIER : "UPDATE_CAP_VERIFIER",
   GET_ALL_CAP_VERIFIER : "GET_ALL_CAP_VERIFIER",
   GET_CAP_VERIFIER_BY_ID : "GET_CAP_VERIFIER_BY_ID",
   SET_CAP_VERIFIER : "SET_CAP_VERIFIER",


};

export default capVerifierActions;